<template>
  <div class="home">
    <div class="home-page1 page-bg">
      <div class="home-page1-test">
        <div class="home-page1-test-bg"></div>
      </div>
      <div
        class="width-1200 animate__animated animate__fadeIn animate__delay-0.5s p-r"
      >
        <img
          class="home-page1-title"
          src="../../images/home/banner-04.png"
          width="433"
        />
        <p class="font-size-16 color-333 margin-t-18 p-r" style="z-index: 9">
          帮助译者实现语言资产数字化，明确版权归属，获得长期收益
        </p>
        <div class="home-page1-button margin-t-30">
          <a-button class="margin-r-30" size="large" @click="gotoTxt">
            <span>快速体验</span>
          </a-button>
          <a-button class="second margin-r-30" size="large" @click="gotoMarket">
            <span class="font-weight-500">创建孪生引擎</span>
          </a-button>
          <a-button
            class="second"
            size="large"
            @click="gotoBuildFunc"
            style="z-index: 10"
          >
            <span class="font-weight-500">引擎共建</span>
          </a-button>
        </div>
        <img
          class="home-page1-bg-2"
          src="../../images/home/banner-02.png"
          width="940"
        />
        <img
          class="home-page1-bg-3"
          src="../../images/home/banner-03.png"
          width="520"
        />
      </div>

      <div class="home-page-item color-type-1" style="margin-top: 120px">
        <div class="left" style="z-index: 2">
          <div class="banner-logo">
            <img src="../../images/home/item01.png" />
          </div>
          <div class="banner-border"></div>
        </div>
        <div class="right">
          <div class="right-one animate__animated animate__fadeInLeft">
            <a-button>效能提升</a-button>
          </div>
          <div class="right-two animate__animated animate__fadeInLeft">
            垂直引擎翻译直接通过率
            <br />
            较通用引擎
            <span>显著提升20%</span>
          </div>
          <div class="right-three animate__animated animate__fadeInLeft">
            基于语联网任度神经网络翻译模型，独创翻译矩阵，深耕垂直领域，让翻译更精准
          </div>
          <div class="right-four animate__animated animate__fadeInUp">
            <img src="@/images/home/item-banner01.png" />
          </div>
        </div>
      </div>

      <div class="home-page-item color-type-2">
        <div class="left">
          <div class="banner-logo">
            <img src="../../images/home/item02.png" />
          </div>
          <div class="banner-border"></div>
        </div>
        <div class="right" v-show="scrollTop + windowHeight > 1292">
          <div class="right-one animate__animated animate__fadeInLeft">
            <a-button>数据安全</a-button>
          </div>
          <div class="right-two animate__animated animate__fadeInLeft">
            语言资产区块链明确归属
            <br />
            算法“学习”而非“拷贝”数据
          </div>
          <div class="right-three animate__animated animate__fadeInLeft">
            资产上传即确认归属，术语语料不会被盗取，仅部分数据抽样可见
          </div>
          <div class="right-four animate__animated animate__fadeInUp">
            <img src="@/images/home/item-banner02.png" />
          </div>
        </div>
      </div>

      <div
        class="home-page-item color-type-1 animate__animated animate__backInLeft animate__delay-1s"
      >
        <div class="left">
          <div class="banner-logo">
            <img src="../../images/home/item03.png" />
          </div>
          <div class="banner-border"></div>
        </div>
        <div class="right" v-show="scrollTop + windowHeight > 1962">
          <div class="right-one animate__animated animate__fadeInLeft">
            <a-button>联合共建</a-button>
          </div>
          <div class="right-two animate__animated animate__fadeInLeft">
            任度语言大模型加持译客资产
            <br />
            快速训练垂直引擎
          </div>
          <div class="right-three animate__animated animate__fadeInLeft">
            设定引擎方向，译客可自主或多人进行孵化训练，并不断进化更新
          </div>
          <div class="right-four animate__animated animate__fadeInUp">
            <img src="@/images/home/item-banner03.png" />
          </div>
        </div>
      </div>

      <div class="home-page-item color-type-2">
        <div class="left">
          <div class="banner-logo">
            <img src="../../images/home/item04.png" />
          </div>
          <div class="banner-border"></div>
        </div>
        <div class="right" v-show="scrollTop + windowHeight > 2632">
          <div class="right-one animate__animated animate__fadeInLeft">
            <a-button>资产变现</a-button>
          </div>
          <div class="right-two animate__animated animate__fadeInLeft">
            译客收益不止一种
            <br />
            让孪生引擎为你工作
          </div>
          <div class="right-three animate__animated animate__fadeInLeft">
            除翻译收入，数据资产化的引擎被使用，共创者均可获得收益
          </div>
          <div class="right-four animate__animated animate__fadeInUp">
            <img src="@/images/home/item-banner04.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="home-page2 page-bg" v-if="false">
      <div class="width-1200">
        <div class="home-page2-title">
          <p class="main-title-new">和普通机翻引擎相比</p>
          <p class="sub-title-new">
            孪生引擎它
            <span>不一样</span>
          </p>
        </div>
        <a-row class="home-page2-content">
          <a-col :span="12" class="padding-r-60">
            <p class="font-size-14 color-ddd">TwinsMT</p>
            <p class="home-page2-content-title font-size-30 color-333">
              <span class="font-weight-600">属于译者</span>
              的机翻引擎
            </p>
            <div
              class="home-page2-content-list margin-t-70 display-flex align-start"
            >
              <img src="../../images/home/banner-07.png" width="64" />
              <div class="margin-l-16">
                <p
                  class="font-size-20 color-333 font-weight-600 line-height-25 margin-t-4"
                >
                  来自于译者的数字克隆
                </p>
                <p class="font-size-16 color-333 line-height-24 margin-t-8">
                  经验技能被学习，翻译思维被模拟，语言资产被使用，机翻引擎逐渐进化的更像译者本人。
                </p>
              </div>
            </div>
            <div
              class="home-page2-content-list margin-t-70 display-flex align-start"
            >
              <img src="../../images/home/banner-08.png" width="64" />
              <div class="margin-l-16">
                <p
                  class="font-size-20 color-333 font-weight-600 line-height-25"
                >
                  受控于译者的自主管理
                </p>
                <p class="font-size-16 color-333 line-height-24 margin-t-8">
                  自主管理孵化、自主公开获益，机翻引擎归译者所有
                </p>
              </div>
            </div>
          </a-col>
          <a-col :span="12" class="text-right">
            <img src="../../images/home/banner-09.png" width="560" alt="" />
          </a-col>
        </a-row>
        <a-row class="home-page2-content">
          <a-col :span="12" class="text-right padding-r-150">
            <img src="../../images/home/banner-10.png" width="560" alt="" />
          </a-col>
          <a-col :span="12" class="padding-l-40">
            <p class="font-size-14 color-ddd">TwinsMT</p>
            <p class="home-page2-content-title font-size-30 color-333">
              更是译者
              <span class="font-weight-600">未来的工作方式</span>
            </p>
            <div
              class="home-page2-content-list margin-t-70 display-flex align-start"
            >
              <img src="../../images/home/banner-11.png" width="64" />
              <div class="margin-l-16">
                <p
                  class="font-size-20 color-333 font-weight-600 line-height-25"
                >
                  语言资产利用更加安全
                </p>
                <p class="font-size-16 color-333 line-height-24 margin-t-8">
                  术语语料不会被他人盗取，算法“消化”数据而非“拷贝”数据
                </p>
              </div>
            </div>
            <div
              class="home-page2-content-list margin-t-70 display-flex align-start"
            >
              <img src="../../images/home/banner-12.png" width="64" />
              <div class="margin-l-16">
                <p
                  class="font-size-20 color-333 font-weight-600 line-height-25"
                >
                  让引擎参与工作，让资产流动变现
                </p>
                <p class="font-size-16 color-333 line-height-24 margin-t-8">
                  译者不在依赖机翻引擎去工作，而是让引擎为自己工作
                </p>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="home-page3 page-bg" v-if="false">
      <div class="home-page1-bg-l"></div>
      <div class="home-page1-bg-r"></div>
      <div class="width-1200">
        <div class="home-page3-title margin-b-90">
          <p class="main-title">
            共同建设 TwinsMT
            <br />
            <span>你可以收获什么？</span>
          </p>
        </div>
        <a-row class="home-page3-content">
          <a-col :span="8" :push="2">
            <div class="home-page3-content-img">
              <img src="../../images/home-banner1.jpg" alt="" />
            </div>
            <p class="margin-t-30">
              结识志同道合的伙伴，共同维护自己的圈子，享受数据共享的价值
            </p>
          </a-col>
          <a-col :span="8" :push="6">
            <div class="home-page3-content-img">
              <img src="../../images/home-banner2.jpg" alt="" />
            </div>
            <p class="margin-t-30">
              无论是共享数据、数据抽查、言帮日常管理，只需要你贡献自己的智慧，就能获得译力或现金收益，充分释放当代译员价值
            </p>
          </a-col>
        </a-row>
        <a-row class="home-page3-content margin-t-80">
          <a-col :span="8" :push="2">
            <div class="home-page3-content-img">
              <img src="../../images/home-banner3.jpg" alt="" />
            </div>
            <p class="margin-t-30">
              众人智慧，打造自己的专属机器翻译引擎，这个引擎会是你日常工作的利器，助你效率提升
            </p>
          </a-col>
          <a-col :span="8" :push="6">
            <div class="home-page3-content-img">
              <img src="../../images/home-banner4.jpg" alt="" />
            </div>
            <p class="margin-t-30">
              专属TwinsMT通过评测上架引擎仓库，供其他用户使用，根据调用量，作为共建者，让您真正实现躺着也能赚钱
            </p>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="home-page4 page-bg" v-if="false">
      <div class="home-page2-bg-l"></div>
      <div class="home-page2-bg-r"></div>
      <div class="width-1200">
        <div class="home-page4-title">
          <p class="main-title">TwinsMT创建流程</p>
        </div>
        <ul
          class="home-page4-content display-flex align-center justify-between"
        >
          <li>
            <img
              src="../../images/home-page4-content-icon1.png"
              width="140"
              alt=""
            />
            <p class="margin-t-30">完善基础信息</p>
          </li>
          <li>
            <img
              src="../../images/home-page4-content-icon2.png"
              width="140"
              alt=""
            />
            <p class="margin-t-30">选择基础引擎</p>
          </li>
          <li>
            <img
              src="../../images/home-page4-content-icon3.png"
              width="140"
              alt=""
            />
            <p class="margin-t-30">同步术语数据</p>
          </li>
          <li>
            <img
              src="../../images/home-page4-content-icon4.png"
              width="140"
              alt=""
            />
            <p class="margin-t-30">同步语料数据</p>
          </li>
          <li>
            <img
              src="../../images/home-page4-content-icon5.png"
              width="140"
              alt=""
            />
            <p class="margin-t-30">自定义配置</p>
          </li>
        </ul>
        <div class="padding-t-90 padding-b-90 text-center">
          <a-button
            class="home-page4-content-button"
            size="large"
            type="primary"
            @click="create"
          >
            立即创建
          </a-button>
        </div>
      </div>
    </div>
    <div class="home-page5 page-bg" v-if="false">
      <div class="home-page1-bg-l"></div>
      <div class="home-page1-bg-r"></div>
      <div class="width-1200">
        <div class="home-page3-title margin-b-90">
          <p class="main-title">T计划</p>
        </div>
        <a-row class="home-page5-content" :gutter="[0, 0]">
          <a-col :span="8" class="text-center">
            <img
              src="../../images/home-page5-content-icon1.png"
              width="200"
              alt=""
            />
            <p class="font-size-24 margin-t-30 margin-b-20">TwinsMT孵化对象</p>
            <p class="font-size-16">译者、翻译工作室、翻译公司、高等院校</p>
          </a-col>
          <a-col :span="8" class="text-center">
            <img
              src="../../images/home-page5-content-icon2.png"
              width="200"
              alt=""
            />
            <p class="font-size-24 margin-t-30 margin-b-20">TwinsMT孵化内容</p>
            <p
              class="font-size-16 text-left"
              style="width: 300px; margin: 0 auto"
            >
              提供统一平台，以言帮为基础，共同提供数据、清洗数据、训练机翻、享受收益，打造自治、开放、共享的孪生引擎实验室。
            </p>
          </a-col>
          <a-col :span="8" class="text-center">
            <img
              src="../../images/home-page5-content-icon3.png"
              width="200"
              alt=""
            />
            <p class="font-size-24 margin-t-30 margin-b-20">TwinsMT孵化支持</p>
            <p class="font-size-16">现金、算力、技术(算法)、推广支持</p>
          </a-col>
        </a-row>
      </div>
    </div>

    <!-- 孪生引擎的生态图 -->
    <div class="home-page6 page-bg padding-b-60">
      <div class="width-1200">
        <div class="home-page6-content text-center">
          <div class="home-page6-title padding-t-80 padding-b-40">
            <!--            <p class="main-title-new">环环相扣</p>-->
            <p class="sub-title-new">
              孪生引擎
              <span>生态图</span>
            </p>
          </div>
          <img src="../../images/home-gif.gif" width="1070" alt="" />
          <div class="padding-t-90 padding-b-90 text-center" v-if="false">
            <a-button
              class="home-page6-content-button"
              size="large"
              type="primary"
              @click="create"
            >
              申请孵化
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="home-page7 page-bg" v-if="false">
      <div class="home-page1-bg-l"></div>
      <div class="home-page1-bg-r"></div>
      <div class="width-1200">
        <div class="home-page1-title">
          <p class="main-title">
            打造专属自定义引擎
            <br />
            <span>激活数据资产 享受自治的乐趣</span>
          </p>
          <p class="sub-title margin-t-50">
            如需咨询，请发送邮件至
            <span>service@transn.com</span>
          </p>
        </div>
        <div class="home-page1-button">
          <a-button size="large" @click="goto('yzl')">
            <img src="../../images/yzl.png" alt="" />
            <span class="margin-l-10">前往言值录</span>
          </a-button>
          <a-button size="large" @click="goto('pe')">
            <img src="../../images/pe.png" alt="" />
            <span class="margin-l-10">前往云译客</span>
          </a-button>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="home-page8 page-bg">
      <div class="width-1200 display-flex align-center flex-column">
        <div class="home-page8-title padding-b-60 text-center">
          <div class="sub-title-new">
            我们的
            <span class="color-7a59ff">合作伙伴</span>
          </div>
          <p
            class="color-333 font-weight-400 font-size-24 padding-t-10 padding-b-30"
          >
            —— 院校 ——
          </p>
          <div class="banner-box-1">
            <img src="../../images/home/banner-13-1.png" />
          </div>
          <p class="color-333 font-weight-400 font-size-24 padding-tb-30">
            —— 翻译机构 ——
          </p>
          <div class="banner-box-2">
            <img src="../../images/home/banner-13-2.png" />
          </div>
          <p class="color-333 font-weight-400 font-size-24 padding-tb-30">
            —— 企业 ——
          </p>
          <div class="banner-box-3">
            <img src="../../images/home/banner-13-3.png" />
          </div>
        </div>
      </div>
    </div>

    <!-- 即刻开始 收藏/创建孪生引擎 -->
    <!--    <div class="home-page9 page-bg">-->
    <!--      <div class="width-1200 display-flex align-center flex-column">-->
    <!--        <div class="home-page8-title text-center margin-t-120">-->
    <!--          <p class="main-title-new">即刻开始</p>-->
    <!--          <p class="sub-title-new">-->
    <!--            收藏/创建<span>孪生引擎</span>-->
    <!--          </p>-->
    <!--        </div>-->
    <!--        <div class="home-page1-button margin-t-30">-->
    <!--          <a-button class="margin-r-30" size="large" @click="gotoMarket">-->
    <!--            <span>引擎仓库</span>-->
    <!--          </a-button>-->
    <!--          <a-button class="second" size="large" @click="gotoCreate">-->
    <!--            <span>创建引擎</span>-->
    <!--          </a-button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
  import HeaderView from '@/components/Header/Header.vue'
  import { message } from 'ant-design-vue'
  import { useRoute, useRouter } from 'vue-router'
  import { onMounted, reactive, toRefs, ref } from 'vue'
  import { useStore } from 'vuex'
  import { postConsultationSeek } from '@/http/api.js'
  import mitt from '@/mitt/mitt.js'
  export default {
    name: 'Home',
    components: {
      HeaderView,
    },
    setup() {
      const formRef = ref()
      const router = useRouter()
      const store = useStore()
      const route = useRoute()

      const state = reactive({
        visible: false,
        scrollTop: 0,
        windowHeight: 0,
      })

      const goto = (type) => {
        // window.open('/web/viewer.html?file=' + 'https://qnfile.iol8.com/0073c9ce3f604146be0ad97babc83cc8?attname=%E8%8B%B1%E6%96%87%E8%AE%BA%E6%96%87%E6%9D%90%E6%96%99.pdf');
        if (type == 'pe') {
          window.open(
            `${window.config.pe}?enterpriseId=${sessionStorage.getItem('enterpriseId')}`,
            '_blank'
          )
        } else {
          window.open(window.config.wordpower, '_blank')
        }
      }

      const create = () => {
        message.info('敬请期待')
      }

      // 过滤 channel&invitePeople 字段
      const filterFunc = () => {
        let _url = ''
        if (route.path == '/detail') {
          const _query = route.query
          if (_query.channel) {
            delete _query.channel
          }
          if (_query.invitePeople) {
            delete _query.invitePeople
          }
          _url = `${window.location.origin + window.location.pathname}?id=${
            _query.id
          }&type=${_query.type}`
        } else {
          _url = location.href
        }
        return _url
      }

      const login = () => {
        const shareId = localStorage.shareId || ''
        const channel = localStorage.channel || ''
        const _url = filterFunc()
        let url = shareId
          ? encodeURIComponent(
              _url + `&channel=${channel}&invitePeople=` + shareId
            )
          : channel
            ? encodeURIComponent(
                _url + (_url.includes('?') ? '&' : '?') + `channel=${channel}`
              )
            : encodeURIComponent(_url)
        window.location.href = window.env.login + '/cas/login?service=' + url
        window.localStorage.removeItem('channel')
        window.localStorage.removeItem('shareId')
      }

      // 跳转列表页
      const gotoMarket = () => {
        if (store.state.user.userInfo.casId) {
          // router.push({
          //   path: '/my',
          //   query: {
          //     type: 3,
          //   },
          // })
          const url = `/go/pe_pc_login/pe?redirect=translation&enterpriseId=${sessionStorage.getItem('enterpriseId')}`
          window.open(url, '_blank')
        } else {
          login()
        }
      }

      const gotoTxt = () => {
        router.push({
          path: '/experience',
        })
      }

      const gotoCreate = () => {
        router.push({
          path: '/my',
          query: {
            type: 3,
          },
        })
      }

      const gotoBuildFunc = () => {
        window.open('https://www.iol8.com/saas2/Index', '_blank')
      }

      const initFunc = () => {
        let timer = null
        const setScrollTop = (e) => {
          state.scrollTop = e
        }
        mitt.on('bodyScroll', (res) => {
          if (timer) {
            clearTimeout(timer)
          }

          timer = setTimeout(() => {
            setScrollTop(res.srcElement.scrollTop)
          }, 200)
        })

        state.windowHeight = document.documentElement.clientHeight
      }

      onMounted(() => {
        initFunc()
      })

      return {
        ...toRefs(state),
        formRef,
        goto,
        create,
        gotoMarket,
        gotoTxt,
        gotoCreate,
        gotoBuildFunc,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .home {
    background: white;
    margin-top: -70px;
    overflow: hidden;
    .home-help {
      position: fixed;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      background: white;
      width: 72px;
      border-radius: 8px 0px 0px 8px;
      box-shadow: 0px 4px 12px 0px rgba(122, 89, 255, 0.2);
      svg {
        width: 22px;
        height: 22px;
        margin-bottom: 2px;
      }
      .item {
        height: 72px;
        padding: 12px 0;
        font-size: 12px;
        color: #333;
        text-align: center;
        cursor: pointer;
      }
      .item:nth-child(1) {
        border-bottom: 1px #eeeeee solid;
      }
    }
    .page-bg {
      .home-page1-bg-l {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 385px;
        height: 680px;
        background: url('../../images/home-page1-bg-l.png') no-repeat left
          bottom;
        background-size: cover;
      }
      .home-page1-bg-r {
        position: absolute;
        right: 0;
        top: -70px;
        width: 258px;
        height: 550px;
        background: url('../../images/home-page1-bg-r.png') no-repeat right top;
        background-size: cover;
      }
      .home-page2-bg-l {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 258px;
        height: 540px;
        background: url('../../images/home-page2-bg-l.png') no-repeat left
          bottom;
        background-size: cover;
      }
      .home-page2-bg-r {
        position: absolute;
        right: 0;
        top: 0;
        width: 258px;
        height: 580px;
        background: url('../../images/home-page2-bg-r.png') no-repeat right top;
        background-size: cover;
      }
    }
    .home-page1-button {
      button {
        min-width: 144px;
        height: 48px !important;
        font-size: 16px;
        color: #fff;
        background: var(--primary-color);
        border-radius: 6px;
        border: 1px solid var(--primary-color);
      }
      .second {
        color: #333;
        background: #ffffff;
        border: 1px solid #666666;
      }
      img {
        width: 34px;
        height: 34px;
      }
    }
    .home-page-item {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;

      @mixin page-item(
        $basicColor: var(--primary-color),
        $desalinationColor: #4e26f2
      ) {
        //默认参数 默认12px
        .left {
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-right: 36px;
          height: 610px;
          .banner-logo {
            img {
              width: 64px;
              height: 64px;
            }
          }
          .banner-border {
            width: 1px;
            flex-grow: 1;
            //height: 100px;
            border: 2px solid;
            border-image: linear-gradient(
                180deg,
                $basicColor,
                $desalinationColor
              )
              2 2;
          }
        }
        .right {
          .right-one {
            margin-bottom: 12px;
            .ant-btn {
              //background: #FFFFFF;
              border-radius: 16px;
              border: 1px solid $basicColor;
              font-weight: 600;
              color: $basicColor;
            }
          }
          .right-two {
            font-weight: 600;
            color: #333333;
            font-size: 36px;
            line-height: 50px;
            margin-bottom: 12px;
            span {
              color: $basicColor;
            }
          }
          .right-three {
            color: #666;
            line-height: 24px;
            margin-bottom: 30px;
          }
          .right-four {
            img {
              width: 1100px;
              height: 400px;
            }
          }
        }
      }

      &.color-type-1 {
        $basicColor: var(--primary-color);
        $desalinationColor: #4e26f2;
        @include page-item($basicColor, $desalinationColor);
      }

      &.color-type-2 {
        $basicColor: #00befa;
        $desalinationColor: #e4f1ff;
        @include page-item($basicColor, $desalinationColor);
      }
    }
    .home-page1 {
      position: relative;
      width: 100%;
      .home-page1-test {
        background: url('../../images/home/banner-01.png') no-repeat center top;
        background-size: cover;
        position: absolute;
        top: 0;
        width: 100%;
        height: 750px;
        z-index: 0;
        .home-page1-test-bg {
          width: 100%;
          height: 100%;
          background: linear-gradient(
            180deg,
            rgba(235, 229, 255, 0) 0%,
            #ffffff 100%
          );
        }
      }
      .home-page1-bg-2 {
        position: absolute;
        top: -196px;
        right: -110px;
        animation: rotate 10s linear infinite;
      }
      .home-page1-bg-3 {
        position: absolute;
        bottom: -115px;
        right: 60px;
      }
      .home-page1-title {
        position: relative;
        padding-top: 142px;
        text-align: center;
        color: #fff;
        z-index: 9;
        .main-title {
          font-size: 60px;
          line-height: 1.5;
          span {
            color: #00e8cd;
          }
        }
        .sub-title {
          font-size: 22px;
        }
      }

      .home-page1-content {
        padding: 50px 30px;
        margin-left: -600px;
        position: absolute;
        bottom: -150px;
        left: 50%;
        width: 1200px;
        height: 300px;
        background: linear-gradient(
          180deg,
          #b4a2ff 0%,
          var(--primary-color) 100%
        );
        box-shadow: inset 0px 2px 0px 0px #ffffff;
        border-radius: 20px;
        border: 1px solid #b4a2ff;
        z-index: 1;
        .home-page1-content-col {
          flex: 1;
          .home-page1-title1 {
            font-size: 24px;
            color: #fff;
            font-weight: 600;
          }
          .home-page1-title-line {
            margin: 20px 0;
            height: 1px;
            border: 1px solid;
            border-image: linear-gradient(
                90deg,
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 0.2)
              )
              1 1;
          }
          .home-page1-title2 {
            font-size: 16px;
            color: #ccc;
          }
          span {
            font-size: 18px;
            color: #fff;
            span {
              font-size: 16px;
              color: #ccc;
            }
          }
        }
      }
    }
    .main-title-new {
      font-size: 30px;
      line-height: 1.5;
      color: #333;
      font-weight: 400;
      span {
        color: #00e8cd;
      }
    }
    .sub-title-new {
      font-size: 60px;
      color: #333;
      font-weight: 600;
      span {
        color: var(--primary-color);
      }
    }
    .home-page2 {
      padding-top: 232px;
      padding-bottom: 140px;
      position: relative;
      background: #fff;
      .home-page2-title {
        text-align: center;
        color: #1e1477;

        .main-title {
          font-size: 36px;
          font-weight: bold;
          line-height: 60px;
        }
        .sub-title {
          font-size: 22px;
          line-height: 36px;
        }
      }
      .home-page2-content {
        margin-top: 60px;
        .home-page2-content-sub {
          font-size: 18px;
          font-weight: 400;
          color: #1f1678;
          line-height: 36px;
        }
        .home-page2-content-list {
          // padding-right: 200px;
        }
      }
    }
    .home-page3 {
      position: relative;
      padding: 90px;
      background: #201678;
      .home-page1-bg-r {
        top: 0;
      }
      .home-page3-title {
        text-align: center;
        .main-title {
          font-size: 36px;
          color: #ffffff;
          line-height: 60px;
          span {
            color: #5afac8;
          }
        }
      }
      .home-page3-content {
        .home-page3-content-img {
          width: 400px;
          height: 225px;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        p {
          width: 400px;
          font-size: 18px;
          color: #ffffff;
          line-height: 26px;
        }
      }
    }
    .home-page4 {
      position: relative;
      // height: 726px;
      background: #eaf1fc;
      .home-page4-title {
        padding: 90px 0;
        text-align: center;
        color: #1e1477;
        .main-title {
          font-size: 36px;
          font-weight: bold;
          line-height: 60px;
        }
      }
      .home-page4-content {
        li {
          p {
            text-align: center;
            font-size: 22px;
            color: #1f1678;
            line-height: 30px;
          }
        }
      }
      .home-page4-content-button {
        width: 200px;
        height: 56px;
        background: #d74590;
        &:hover {
          background: rgb(255, 139, 199);
        }
      }
    }
    .home-page5 {
      position: relative;
      padding: 90px;
      background: #201678;
      overflow: hidden;
      .home-page1-bg-l {
        bottom: -420px;
      }
      .home-page1-bg-r {
        top: 0;
        width: 232px;
        height: 495px;
      }
      .home-page3-title {
        text-align: center;
        .main-title {
          font-size: 36px;
          color: #ffffff;
          line-height: 60px;
        }
      }
      .home-page5-content {
        p {
          color: #fff;
        }
      }
    }
    .home-page6 {
      position: relative;
      background: #f9faff;
      .home-page6-content {
        .home-page6-content-button {
          width: 200px;
          height: 56px;
          background: #d74590;
          &:hover {
            background: rgb(255, 139, 199);
          }
        }
        .home-page6-title {
          font-size: 38px;
          font-weight: 400;
          color: #1e1477;
        }
      }
    }
    .home-page7 {
      padding-top: 80px;
      padding-bottom: 50px;
      position: relative;
      background: #201678;
      overflow: hidden;
      .home-page1-bg-r {
        top: 0;
      }
      .home-page1-bg-l {
        bottom: -420px;
      }
      .home-page1-title {
        margin-top: 30px;
        text-align: center;
        color: #fff;
        .main-title {
          font-size: 50px;
          line-height: 1.5;
          span {
            color: #00e8cd;
          }
        }
        .sub-title {
          font-size: 24px;
          span {
            color: #d74590;
          }
        }
      }
      .home-page1-button {
        text-align: center;
        button {
          margin: 57px 33px;
          width: 173px;
          height: 56px;
          color: #cad9ff;
          background: #130c53;
          border-radius: 8px;
          border: 1px solid #392f96;
          &:hover {
            background: rgba($color: #fff, $alpha: 0.1);
          }
        }
      }
    }
    .home-page8 {
      padding-top: 60px;
      padding-bottom: 20px;
      background: url('../../images/home/home-bg-8.png') no-repeat center;
      background-size: cover;
      .home-page8-title {
        font-size: 38px;
        font-weight: 400;
        color: #fff;
      }
    }
    .home-page9 {
      position: relative;
      width: 100%;
      height: 500px;
      background: url('../../images/home/banner-14.png') no-repeat center top;
      background-size: cover;
    }
  }

  .banner-box-1 {
    width: 1200px;
    height: 230px;
    margin: 0 auto;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .banner-box-2 {
    width: 580px;
    height: 100px;
    margin: 0 auto;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .banner-box-3 {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  @keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
    }
    25% {
      -webkit-transform: rotate(90deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    75% {
      -webkit-transform: rotate(270deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
</style>
